const AVC_CODECS = ['avc1.640028', 'avc1.4d0033'];
let _videoCodecOverride = null;
function setVideoCodecOverride(codec) {
    _videoCodecOverride = codec;
}
function getVideoCodecOverride() {
    if (_videoCodecOverride !== null)
        return _videoCodecOverride;
    try {
        const href = typeof globalThis.location?.href === 'string'
            ? globalThis.location.href
            : '';
        if (!href)
            return null;
        return new URL(href).searchParams.get('videoCodec');
    }
    catch {
        return null;
    }
}
function resolveVideoCodecs(defaultCodecs) {
    if (getVideoCodecOverride() === 'avc')
        return AVC_CODECS;
    return defaultCodecs;
}
const Settings = {
    videoEncoderCodecs: [
        'hvc1.1.6.L93.90', // H.265/HEVC codec (widely supported)
        'avc1.4d0033', // H.264/AVC codec (widely supported)
        'avc1.420034',
    ],
    videoEncoderBitrateSd: 250_000, // broadcaster upload bw requirement (4x) 1Mbit/s
    videoEncoderBitrateHd: 1_500_000, // broadcaster upload bw requirement (4x) 6Mbit/s
    videoEncoderBitrateUhd: 3_000_000, // broadcaster upload bw requirement (4x) 12Mbit/s
    videoEncoderKeyFrameInterval: 30, // One keyframe per second at 30fps
    videoEncoderDefaultFrameRate: 30,
    videoEncoderDefaultWidth: 1280,
    videoEncoderDefaultHeight: 720,
    videoEncoderAnnexB: false,
    defaultHeartbeatInterval: 30000,
    speakerHeartbeatInterval: 5000,
    speakerHeartbeatExpiration: 15000,
    viewerCounterUpdateInterval: 1000,
    broadcastMetadataInterval: 10000,
    audioSampleRate: 48000,
    audioNumberOfChannels: 1,
    audioCodec: 'opus',
    // Per-track (mic) Opus bitrate. Explicit baseline: before v2 the value
    // never reached libopus (auto ~51 kbps for 48 kHz mono).
    audioBitrate: 48_000,
    audioFrameSize: 960,
    audioFrameDurationMicroseconds: 20000,
    // Viewer partition: composite HEVC video + Opus audio
    viewerStreamVideoCodecs: ['hvc1.1.6.L93.90'],
    viewerStreamVideoBitrate: 2_500_000,
    viewerStreamAudioCodec: 'opus',
    // Explicit baseline (128000 never reached libopus, see audioBitrate).
    viewerStreamAudioBitrate: 48_000,
    viewerStreamAudioChannels: 2,
    // Low-quality composite on the low content partition (#3) for viewers
    // whose uplink cannot relay the high one (every subscriber forwards the
    // stream to ~3 neighbors). Desktop broadcasters only; ?lowQualityStream=off
    // and localStorage.lowQualityStream=0 turn it off for a session.
    // Media stream parts (content, low content, speaker, one-to-one) are
    // joined with this maximum send-queue age: a media message that waited
    // longer in the send queue toward a neighbor is dropped instead of
    // delivered late, and what is still queued for a neighbor that left the
    // part is withdrawn (network fork branch send-queue-expiry, the release
    // after 103.8.0-rc.10). Above the uplink congestion control's emergency
    // threshold (2000 ms) so that signal stays reachable; 0 = off;
    // ?mediaSendQueueMaxAgeMs=<ms> overrides it for a session.
    mediaSendQueueMaxAgeMs: 2500,
    // Media stream parts also travel on a second, ordered but partially
    // reliable WebRTC data channel between peers that both support it
    // (network fork branch media-channel, 103.8.0-rc.12): a message SCTP
    // could not deliver within this lifetime is abandoned instead of
    // retransmitted, so a burst of packet loss costs the frames of that
    // burst, not a head-of-line stall of the whole connection. Control
    // traffic (heartbeats, roles, keys, plugin messages) stays on the
    // reliable channel; peers without the capability (older versions, the
    // recorder) keep receiving media on it as before. Browsers only: a Node
    // consumer of StreamrWrapper (the recorder) defaults to off regardless
    // of this value. ?mediaChannel=off or localStorage.mediaChannel=0 turns
    // it off for a session, ?mediaChannelLifetimeMs=<ms> changes the lifetime.
    mediaChannelEnabled: true,
    mediaChannelMaxPacketLifeTimeMs: 1500,
    // send-queue watermarks of the media channel: smaller than the reliable
    // channel's so a message does not spend its lifetime waiting in the
    // SCTP buffer on a slow link
    mediaChannelBufferThresholdHigh: 65_536,
    mediaChannelBufferThresholdLow: 16_384,
    // Receiver: a multi-fragment packet still missing a fragment after this
    // long is dropped (with the media channel a fragment can be abandoned by
    // the sender, so waiting longer only holds memory); a packet is also
    // dropped as soon as a newer packet of the same track starts, because
    // the duplicate detector is monotonic per chain.
    incomingPendingPacketMaxAgeMs: 2000,
    lowQualityStreamEnabled: true,
    lowQualityStreamVideoWidth: 640,
    lowQualityStreamVideoHeight: 360,
    lowQualityStreamVideoBitrate: 350_000,
    lowQualityStreamAudioBitrate: 24_000,
    lowQualityStreamAudioBundleFrames: 3,
    lowQualityStreamAudioBundleMaxWaitMs: 70,
    // while both composites are published the high one never sinks below
    // the low one: its congestion floor is raised to this, and below it the
    // host suspends the high composite instead (low-only mode)
    lowQualityStreamHighFloorBps: 1_000_000,
    // what a viewer needs to watch even the low composite: ~0.6 Mbps on the
    // wire (video + audio + envelopes) down, and ~3x that up for relaying.
    // Shown in the "slow connection" notice; keep in step with the profile.
    viewerQualityMinDownlinkMbps: 1,
    viewerQualityMinUplinkMbps: 2,
    // Recording: the host stores the packets it publishes for the composite
    // (src/engine/streamrapp/recording). A segment is cut at the first video
    // keyframe after this many seconds.
    recordingSegmentTargetSeconds: 4,
    // Upload rate while the broadcast is live, so that the recording never
    // competes with the stream for the uplink; what does not fit waits in
    // the spool and goes out unthrottled after the broadcast. 0 = spool
    // only while live (the default on mobile).
    recordingLiveUploadBps: 1_000_000,
    recordingLiveUploadBpsMobile: 0,
    // what may wait in the spool (OPFS) before the recording stops
    recordingSpoolMaxBytes: 4 * 1024 * 1024 * 1024,
    recordingSpoolMaxBytesMobile: 1024 * 1024 * 1024,
    // Opus encoder lookahead at 48 kHz (libopus default), the pre-skip of
    // the recorded audio
    recordingOpusPreSkip: 312,
    // one 20 ms frame of Opus silence (CELT, fullband, stereo); fills audio
    // gaps in a recording without storing anything
    recordingOpusSilenceFrame: [0xfc, 0xff, 0xfe],
    // RTMP output: composite AVC video + AAC audio
    rtmpVideoCodecs: ['avc1.4d0033', 'avc1.420034'],
    rtmpVideoBitrate: 5_000_000,
    rtmpAudioCodec: 'mp4a.40.2',
    rtmpAudioBitrate: 128000,
    rtmpAudioChannels: 2,
    // Speaker partition: per-track HEVC video + Opus audio
    speakerTrackVideoCodecs: ['hvc1.1.6.L93.90'],
    speakerTrackVideoBitrate: 500_000,
    speakerTrackAudioCodec: 'opus',
    // Per-role video defaults (resolution + bitrate for per-track encoding)
    cohostVideoWidth: 1920,
    cohostVideoHeight: 1080,
    cohostVideoBitrate: 1_500_000,
    cohostCallVideoWidth: 1280,
    cohostCallVideoHeight: 720,
    cohostCallVideoBitrate: 1_000_000,
    speakerVideoWidth: 1280,
    speakerVideoHeight: 720,
    speakerVideoBitrate: 1_000_000,
    guestVideoWidth: 640,
    guestVideoHeight: 360,
    guestVideoBitrate: 500_000,
    cameraVideoWidth: 1920,
    cameraVideoHeight: 1080,
    cameraVideoBitrate: 1_500_000,
    // Sender-side uplink congestion control (v1: the video encoder bitrate is
    // the only actuator). On by default; ?uplinkCc=off or localStorage
    // uplinkCc=0 turns it off; any key below is overridable per session with
    // ?uplinkCcTune=<key without the uplinkCc prefix, lower camel>:<value>,...
    // See src/engine/streamrapp/UplinkBitrateController.ts for the law.
    uplinkCcTickMs: 500,
    // `oldestQueuedMs` of the worst neighbor ~= one-way delay being added
    uplinkCcCongestedAgeMs: 400,
    uplinkCcClearAgeMs: 100,
    uplinkCcEmergencyAgeMs: 2000,
    // with the media channel on, SCTP abandons a message after its lifetime
    // (mediaChannelMaxPacketLifeTimeMs), so in a full outage the send-queue
    // age saturates below that; the emergency threshold must sit under it
    uplinkCcMediaChannelEmergencyAgeMs: 1000,
    uplinkCcCongestedTicks: 2,
    uplinkCcClearTicks: 6,
    // 2x the datachannel high watermark: the JS send queue is really forming
    uplinkCcBacklogBytesThreshold: 262_144,
    uplinkCcDecreaseFactor: 0.85,
    uplinkCcEmergencyFactor: 0.6,
    uplinkCcIncreaseFactor: 1.05,
    uplinkCcIncreaseMinStepBps: 25_000,
    uplinkCcQuantumBps: 25_000,
    uplinkCcDecreaseHoldMs: 1000,
    uplinkCcIncreaseHoldMs: 3000,
    uplinkCcEmergencyHoldMs: 2000,
    uplinkCcCapacityFraction: 0.9,
    // extra safety divisor on the drain estimate (the non-video traffic
    // itself is measured: offered - encoder output)
    uplinkCcOverheadFactor: 1.0,
    // lower bound for the non-video traffic estimate (audio + envelopes)
    uplinkCcAudioReserveBps: 96_000,
    // drain/offered rates are 1 s windows and the datachannel flushes in
    // bursts on slow links (a 1 s window often reads 0): average this many
    // ticks before deciding saturation / draining / capacity
    uplinkCcRateWindowTicks: 8,
    // offered > saturatedRatio x sent: the link is the bottleneck, so the
    // sent rate is a usable capacity estimate (capacity clamp)
    uplinkCcSaturatedRatio: 1.1,
    // offered < drainingRatio x sent: the backlog is already shrinking, hold
    // further regular decreases (emergency steps still apply)
    uplinkCcDrainingRatio: 0.95,
    uplinkCcStaleSampleMs: 2000,
    // no neighbor with statistics for this long (nobody receives): forget the
    // throttling so the next neighbor starts from the profile bitrate
    uplinkCcIdleResetMs: 10_000,
    uplinkCcOvershootRatio: 1.3,
    uplinkCcOvershootMs: 2000,
    // Floors are UNVERIFIED: no HEVC hardware encoder documents a minimum
    // bitrate, measure per platform and tune.
    uplinkCcFloorBpsUpTo360p: 150_000,
    uplinkCcFloorBpsUpTo720p: 300_000,
    uplinkCcFloorBpsUpTo1080p: 600_000,
    uplinkCcFloorBpsAbove1080p: 1_000_000,
    uplinkCcAbsoluteMinBps: 50_000,
    // 'median' | 'max': how the host composite aggregates its viewer neighbors
    uplinkCcCompositePolicy: 'median',
    uplinkCcStatsIntervalMs: 1000,
    uplinkCcEncoderIdlePruneMs: 10_000,
    // An in-place bitrate cut is checked against what the encoder produces:
    // VideoToolbox behind Chrome on macOS 27 accepts a new bitrate and keeps
    // producing the old one. Judged inPlaceCheckMs after the last change of
    // a run of cuts, over the last 3 s of output. Output above
    // inPlaceToleranceRatio x the new bitrate that fell by less than
    // inPlaceMinDeliveredShare of the requested cut (cuts under
    // inPlaceMinCutShare are not judged) was not delivered: the encoder is
    // rebuilt with the bitrate, and the encoders of that codec then change
    // bitrate by rebuilding. Every cut at once; a raise only at the ceiling
    // or from rebuildRaiseRatio x the running bitrate, a rebuild restarts
    // the encoder's rate control.
    uplinkCcInPlaceCheckMs: 4500,
    uplinkCcInPlaceToleranceRatio: 1.1,
    uplinkCcInPlaceMinCutShare: 0.15,
    uplinkCcInPlaceMinDeliveredShare: 0.25,
    uplinkCcRebuildRaiseRatio: 1.3,
    // v2: extremely-low-bandwidth ladder per encoder kind. Levels: 0 normal,
    // 1 lean audio (leanAudioBitrate + leanAudioBundleFrames per packet),
    // 2 video off (ended on the wire, resumed with a keyframe at the floor).
    // See src/engine/streamrapp/LowBandwidthLadder.ts.
    uplinkCcLowBwMaxLevel: 2, // 0 = ladder off
    uplinkCcCompositeLowBwMaxLevel: 2,
    uplinkCcLowBwEnterMs: 5000,
    // entry window while the sample is in emergency (>= emergencyAgeMs of
    // queue): a link that cannot even carry the non-video traffic queues
    // ~0.8 Mbit per second of hesitation
    uplinkCcLowBwEmergencyEnterMs: 1000,
    uplinkCcVideoResumeClearMs: 15_000,
    uplinkCcVideoResumeBackoffMax: 8,
    uplinkCcVideoResumeBackoffWindowMs: 120_000,
    // resume gate: trust the last capacity estimate this long
    uplinkCcCapMemoryMs: 60_000,
    uplinkCcResumeCapFraction: 0.8,
    // fast resume after an outage: within this window after a video pause,
    // a backlog that flushes at >= resumeCapFraction of the demand proves
    // the link is back and video resumes at once (0 = off); a pause this
    // soon after a fast resume takes the slow path instead (the link is
    // not carrying the floor)
    uplinkCcVideoFastResumeWindowMs: 10_000,
    uplinkCcVideoFastResumeRetryMs: 30_000,
    // per-message framing a resumed video stream adds (~30 msg/s)
    uplinkCcVideoEnvelopeReserveBps: 80_000,
    uplinkCcAudioRestoreClearMs: 10_000,
    uplinkCcLeanAudioBitrate: 24_000,
    uplinkCcLeanAudioBundleFrames: 3,
    uplinkCcAudioBundleMaxWaitMs: 70,
    // test hooks: force a level (1|2) for lowBwForceMs (0 = for the session),
    // starting lowBwForceAfterMs after the ladder's first tick
    uplinkCcLowBwForceLevel: 0,
    uplinkCcLowBwForceMs: 0,
    uplinkCcLowBwForceAfterMs: 0,
    // ladder ceiling of the low-quality composite (1 = lean audio only: the
    // low stream is the fallback and never goes video-off by default)
    uplinkCcLowQualityLowBwMaxLevel: 1,
    // Viewer quality: which content partition a viewer relays. Fed by the
    // viewer's own send queues to its neighbors on the joined partition
    // (median across neighbors), same sample classes as uplinkCc*.
    // ?viewerQualityTune=key:value,... overrides any of these.
    viewerQualityLowPartition: 3,
    viewerQualityTickMs: 500,
    viewerQualityDowngradeMs: 3000,
    viewerQualityEmergencyDowngradeMs: 1000,
    viewerQualityUpgradeClearMs: 30_000,
    viewerQualityUpgradeBackoffMax: 8,
    viewerQualityUpgradeBackoffWindowMs: 180_000,
    viewerQualityMinDwellMs: 10_000,
    viewerQualityCapMemoryMs: 60_000,
    viewerQualityUpgradeCapFactor: 1.2,
    viewerQualityAssumedFanout: 3,
    // the high composite on the wire: video + audio + ~80 envelopes/s
    viewerQualityHighStreamBps: 2_900_000,
    // the low composite on the wire (350k video + 24k audio + envelopes)
    viewerQualityLowStreamBps: 600_000,
    // an uplink failure needs actual relay load: the source plus at least
    // one downstream neighbor on the low partition
    viewerQualityFailMinNeighbors: 2,
    // Downlink: how late the content arrives (queueing delay above the
    // receiver's own baseline, see DownlinkDelayEstimator). Late for the
    // downgrade window moves a viewer to the low stream; on the low stream,
    // late and not draining for the fail window means this downlink cannot
    // carry even that.
    viewerQualityDownlinkDelayMs: 1500,
    viewerQualityDownlinkEmergencyMs: 4000,
    viewerQualityDownlinkClearMs: 400,
    viewerQualityDownlinkFailMs: 30_000,
    viewerQualityDownlinkFailImproveMs: 1000,
    // A probe of the high partition that fails on the downlink (abandoned
    // before the flip, or flipped and then late) costs ~20 s of poor
    // playback on the low stream (EC2 sq3, 2026-09-22): the rate received
    // while the probe saturated the link is remembered as this downlink's
    // capacity and no probe is made while the memory says the high
    // partition (neighbors x high stream, with headroom) cannot fit. The
    // memory lasts this long, doubling on every further failed probe up to
    // the max; a rate below the floor was a stall, not a capacity.
    viewerQualityDownlinkCapMemoryMs: 300_000,
    viewerQualityDownlinkCapMemoryMaxMs: 3_600_000,
    viewerQualityDownlinkCapMinBps: 200_000,
    // the pending partition's layer-1 join can miss the host's entry-point
    // record and recover through the network-split avoidance retries
    // (0/1/3/7/15 s after the join): leave room for the 15 s attempt
    viewerQualityUpgradeKeyframeTimeoutMs: 20_000,
    // a remembered auto decision seeds the next session on this device
    viewerQualityMemoryTtlMs: 21_600_000,
    // "slow connection" failure while on the low partition
    viewerQualityFailCongestedMs: 30_000,
    viewerQualityFailEmergencyMs: 10_000,
    viewerQualityFailUnderflows: 6,
    viewerQualityFailWindowMs: 60_000,
    viewerQualityNoMediaMs: 15_000,
    // while the viewer's own relay queue is congested the association is
    // stalled by its backlog (inbound starves too): judge no-media later
    viewerQualityNoMediaCongestedMs: 60_000,
    viewerQualityFailRetryMs: 60_000,
    viewerQualityFailRetryBackoffMax: 4,
    // Speech detection (voice activity)
    speechDetectionPollIntervalMs: 50,
    speechStartThreshold: 0.01,
    speechStopThreshold: 0.005,
    speechStartDebounceMs: 100,
    speechStopDebounceMs: 1000,
    // Dominant speaker tracking (receiver side)
    dominantSpeakerSwitchMargin: 0.05,
    dominantSpeakerSwitchDebounceMs: 500,
    // Signature verification policy
    videoVerificationSamplingRate: 0.1,
    maxFragmentSize: 64000, // 64KB - estimated size of protocol headers
    optimalDelayWindowLength: 60,
    optimalDelayMinSamplesToStart: 15,
    // Tail-aware: localhost WebRTC bunches frames into pairs, leaving ~80–100ms
    // tail gaps that p95 ignores. p99 + larger safety covers those tails.
    optimalDelayPercentile: 0.95,
    optimalDelaySafetyFactor: 0.3,
    optimalDelayMinSafetyMs: 50,
    optimalDelayUnderflowBoostMs: 40,
    optimalDelayUnderflowDecaySeconds: 5,
    optimalDelayDecreaseRate: 0.05,
    optimalDelayAutonomousDecreasePerSec: 5,
};

export { Settings, getVideoCodecOverride, resolveVideoCodecs, setVideoCodecOverride };
